import { ShippingIcon } from "../components/icons";
const services = [
  {
    code: "tps",
    title: "Darat",
    icon: ShippingIcon,
  },
  {
    code: "tpi",
    title: "Instant",
    icon: ShippingIcon,
  },
  {
    code: "tpx",
    title: "Express",
    icon: ShippingIcon,
  },
];

export { services };
